import { addCallback } from '../../lib/teact/teactn';
import type { GlobalState } from '../../global/types';

import { logAuditEvent } from './audit';
import { detectAnomalousSession, registerDeviceSession } from './fingerprint';
import { loadInvestigationDb } from './store';
import { notifyInvestigation } from './notifications';

let lastAuthUserId: string | undefined;
let screenshotHookInstalled: boolean;

export function initInvestigation() {
  void loadInvestigationDb();
  installScreenshotHook();

  addCallback((global: GlobalState) => {
    if (global.auth.state !== 'authorizationStateReady' || !global.currentUserId) {
      return;
    }

    if (global.currentUserId !== lastAuthUserId) {
      lastAuthUserId = global.currentUserId;
      void onUserReady(global.currentUserId);
    }
  });
}

async function onUserReady(userId: string) {
  await registerDeviceSession(userId);
  await logAuditEvent('login', { userId });

  const anomaly = await detectAnomalousSession(userId);
  if (anomaly) {
    await logAuditEvent('anomaly_login', {
      userId,
      detail: 'New device fingerprint detected',
    });
    await notifyInvestigation(
      'Nusantara Security',
      'Login dari perangkat baru terdeteksi. Periksa Sesi Perangkat di Investigasi.',
      'warning',
    );
  }
}

function installScreenshotHook() {
  if (screenshotHookInstalled) return;
  screenshotHookInstalled = true;

  document.addEventListener('keyup', (e) => {
    if (e.key === 'PrintScreen') {
      void logAuditEvent('screenshot_attempt', { detail: 'PrintScreen key' });
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      void logAuditEvent('screenshot_attempt', { detail: 'Tab hidden (possible capture)' });
    }
  });
}
